// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../bos/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../bos/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.document-viewer-container {
  height: 100%;
}
.document-viewer-container .bg-teal {
  background-color: #00556e;
}
.document-viewer-container .bg-teal .k-expander-title,
.document-viewer-container .bg-teal .k-expander-indicator {
  color: #fff;
}
.document-viewer-container .documentslisting {
  overflow-y: scroll;
  scrollbar-width: thin;
}
.document-viewer-container .card-55 {
  scrollbar-width: thin;
}
.document-viewer-container .card-50 {
  scrollbar-width: thin;
}
.document-viewer-container .custom-title {
  text-transform: none;
}
.document-viewer-container .attachments-card-body {
  padding: 12px 10px;
}
.document-viewer-container .border-none {
  border: none;
}
.document-viewer-container .content-text {
  cursor: pointer;
}
.document-viewer-container .fa-xmark:hover,
.document-viewer-container .fa-trash:hover {
  color: #c82333;
}
.document-viewer-container .cursor-pointer {
  cursor: pointer;
}
.document-viewer-container .iframe {
  height: 100%;
  min-height: 650px;
  width: 100%;
  height: -moz-available;
  height: fill-available;
  width: -webkit-fill-available;
  width: -moz-available;
}
.document-viewer-container .selected {
  font-weight: bolder;
}
.document-viewer-container .rename-input,
.document-viewer-container .rename-input:focus {
  border: none;
  border-bottom: 1px solid #e9ebec;
  width: 40vw;
}
.document-viewer-container :focus-visible {
  outline: none;
}
.document-viewer-container .custom-dialog {
  width: 50vh !important;
}
.document-viewer-container .custom-dialog .k-card,
.document-viewer-container .custom-dialog .k-card-header {
  border-color: #fff;
}
.document-viewer-container .custom-dialog .k-input-inner,
.document-viewer-container .custom-dialog .k-window-titlebar {
  background-color: #fff;
}
.document-viewer-container .custom-dialog .k-window.k-dialog {
  border-radius: 16px;
}
.document-viewer-container .custom-dialog .k-card {
  width: 50vh;
}
.document-viewer-container .k-label.k-form-label {
  color: #424242;
  font-weight: bold;
}
.document-viewer-container .card-close {
  position: absolute;
  top: 5px;
  right: 5px;
  float: right !important;
  color: #c82333 !important;
}
.document-viewer-container .k-button-solid-primary {
  background-color: #2f80ed;
}
.document-viewer-container .k-upload > .k-actions {
  display: none;
}
.document-viewer-container .k-dropzone.k-upload-dropzone {
  visibility: hidden;
  border: none;
  height: 0.5px;
}
.document-viewer-container .k-upload {
  border: none;
  height: 0.5px;
}
.document-viewer-container .k-expander-header {
  padding: 6px 15px;
}
.document-viewer-container .k-tabstrip-content:focus {
  outline-color: #e9ebec;
  outline-style: solid;
}
.document-viewer-container .fa:hover {
  color: #00556e;
}
.document-viewer-container .img-container {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
.document-viewer-container .img-container img,
.document-viewer-container .img-container video {
  max-width: 100%;
  object-fit: contain;
}
.document-viewer-container .k-card.border-none.k-card-vertical {
  z-index: 1;
}
.document-viewer-container .prevent-select {
  -webkit-user-select: none;
  /* Safari */
  -ms-user-select: none;
  /* IE 10 and IE 11 */
  user-select: none;
  /* Standard syntax */
}
.document-viewer-container .clear-bordered {
  border: 1px solid #B8BFC1 !important;
  color: #424242 !important;
}
.document-viewer-container .doclist-container {
  max-height: 30vh;
}
.document-viewer-container .k-card {
  border: none;
}
.document-viewer-container .action-buttons-container {
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 1rem;
}
.document-viewer-container .action-buttons-container .action-buttons-wrapper {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  justify-content: center;
}
.document-viewer-container .action-buttons-container .action-buttons-wrapper .action-button {
  min-width: 180px;
  padding: 0.5rem 1.5rem;
  border: none;
  transition: all 0.2s ease;
  display: flex;
  justify-content: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.document-viewer-container .action-buttons-container .action-buttons-wrapper .action-button .button-content {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
.document-viewer-container .action-buttons-container .action-buttons-wrapper .action-button .button-text {
  font-weight: 500;
}
.document-viewer-container .docviewer-wrapper .k-button-icon {
  display: none !important;
}`, "",{"version":3,"sources":["webpack://./../gui/src/DocumentViewerStyles.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;AACE;EACE,yBAAA;AACJ;AACI;;EAEE,WAAA;AACN;AAGE;EACE,kBAAA;EACA,qBAAA;AADJ;AAIE;EACE,qBAAA;AAFJ;AAKE;EACE,qBAAA;AAHJ;AAME;EACE,oBAAA;AAJJ;AAOE;EACE,kBAAA;AALJ;AAQE;EACE,YAAA;AANJ;AASE;EACE,eAAA;AAPJ;AAUE;;EAEE,cAAA;AARJ;AAWE;EACE,eAAA;AATJ;AAYE;EACE,YAAA;EACA,iBAAA;EACA,WAAA;EACA,sBAAA;EACA,sBAAA;EACA,6BAAA;EACA,qBAAA;AAVJ;AAaE;EACE,mBAAA;AAXJ;AAcE;;EAEE,YAAA;EACA,gCAAA;EACA,WAAA;AAZJ;AAeE;EACE,aAAA;AAbJ;AAgBE;EACE,sBAAA;AAdJ;AAgBI;;EAEE,kBAAA;AAdN;AAiBI;;EAEE,sBAAA;AAfN;AAkBI;EACE,mBAAA;AAhBN;AAmBI;EACE,WAAA;AAjBN;AAqBE;EACE,cAAA;EACA,iBAAA;AAnBJ;AAsBE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,uBAAA;EACA,yBAAA;AApBJ;AAuBE;EACE,yBAAA;AArBJ;AAwBE;EACE,aAAA;AAtBJ;AAyBE;EACE,kBAAA;EACA,YAAA;EACA,aAAA;AAvBJ;AA0BE;EACE,YAAA;EACA,aAAA;AAxBJ;AA2BE;EACE,iBAAA;AAzBJ;AA4BE;EACE,sBAAA;EACA,oBAAA;AA1BJ;AA6BE;EACE,cAAA;AA3BJ;AA8BE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AA5BJ;AA+BE;;EAEE,eAAA;EACA,mBAAA;AA7BJ;AAgCE;EACE,UAAA;AA9BJ;AAiCE;EACE,yBAAA;EACA,WAAA;EACA,qBAAA;EACA,oBAAA;EACA,iBAAA;EACA,oBAAA;AA/BJ;AAkCE;EACE,oCAAA;EACA,yBAAA;AAhCJ;AAmCE;EACE,gBAAA;AAjCJ;AAoCE;EACE,YAAA;AAlCJ;AAsCE;EACE,aAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;AApCJ;AAsCI;EACE,aAAA;EACA,SAAA;EACA,eAAA;EACA,uBAAA;AApCN;AAsCM;EACE,gBAAA;EACA,sBAAA;EACA,YAAA;EACA,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,wCAAA;AApCR;AAsCQ;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AApCV;AAuCQ;EACE,gBAAA;AArCV;AA2CE;EACE,wBAAA;AAzCJ","sourcesContent":[".document-viewer-container {\n  height: 100%;\n\n  .bg-teal {\n    background-color: #00556e;\n\n    .k-expander-title,\n    .k-expander-indicator {\n      color: #fff;\n    }\n  }\n\n  .documentslisting {\n    overflow-y: scroll;\n    scrollbar-width: thin;\n  }\n\n  .card-55 {\n    scrollbar-width: thin;\n  }\n\n  .card-50 {\n    scrollbar-width: thin;\n  }\n\n  .custom-title {\n    text-transform: none;\n  }\n\n  .attachments-card-body {\n    padding: 12px 10px;\n  }\n\n  .border-none {\n    border: none;\n  }\n\n  .content-text {\n    cursor: pointer;\n  }\n\n  .fa-xmark:hover,\n  .fa-trash:hover {\n    color: #c82333;\n  }\n\n  .cursor-pointer {\n    cursor: pointer;\n  }\n\n  .iframe {\n    height: 100%;\n    min-height: 650px;\n    width: 100%;\n    height: -moz-available;\n    height: fill-available;\n    width: -webkit-fill-available;\n    width: -moz-available;\n  }\n\n  .selected {\n    font-weight: bolder;\n  }\n\n  .rename-input,\n  .rename-input:focus {\n    border: none;\n    border-bottom: 1px solid #e9ebec;\n    width: 40vw;\n  }\n\n  :focus-visible {\n    outline: none;\n  }\n\n  .custom-dialog {\n    width: 50vh !important;\n\n    .k-card,\n    .k-card-header {\n      border-color: #fff;\n    }\n\n    .k-input-inner,\n    .k-window-titlebar {\n      background-color: #fff;\n    }\n\n    .k-window.k-dialog {\n      border-radius: 16px;\n    }\n\n    .k-card {\n      width: 50vh;\n    }\n  }\n\n  .k-label.k-form-label {\n    color: #424242;\n    font-weight: bold;\n  }\n\n  .card-close {\n    position: absolute;\n    top: 5px;\n    right: 5px;\n    float: right !important;\n    color: #c82333 !important;\n  }\n\n  .k-button-solid-primary {\n    background-color: #2f80ed;\n  }\n\n  .k-upload>.k-actions {\n    display: none;\n  }\n\n  .k-dropzone.k-upload-dropzone {\n    visibility: hidden;\n    border: none;\n    height: 0.5px;\n  }\n\n  .k-upload {\n    border: none;\n    height: 0.5px;\n  }\n\n  .k-expander-header {\n    padding: 6px 15px;\n  }\n\n  .k-tabstrip-content:focus {\n    outline-color: #e9ebec;\n    outline-style: solid;\n  }\n\n  .fa:hover {\n    color: #00556e;\n  }\n\n  .img-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    overflow: hidden;\n  }\n\n  .img-container img,\n  .img-container video {\n    max-width: 100%;\n    object-fit: contain;\n  }\n\n  .k-card.border-none.k-card-vertical {\n    z-index: 1\n  }\n\n  .prevent-select {\n    -webkit-user-select: none;\n    /* Safari */\n    -ms-user-select: none;\n    /* IE 10 and IE 11 */\n    user-select: none;\n    /* Standard syntax */\n  }\n\n  .clear-bordered {\n    border: 1px solid #B8BFC1 !important;\n    color: #424242 !important;\n  }\n\n  .doclist-container {\n    max-height: 30vh;\n  }\n\n  .k-card {\n    border: none;\n  }\n\n  // CSS to add to DocumentViewerStyles.scss\n  .action-buttons-container {\n    display: flex;\n    justify-content: center;\n    width: 100%;\n    margin-top: 1rem;\n\n    .action-buttons-wrapper {\n      display: flex;\n      gap: 1rem;\n      flex-wrap: wrap;\n      justify-content: center;\n\n      .action-button {\n        min-width: 180px;\n        padding: 0.5rem 1.5rem;\n        border: none;\n        transition: all 0.2s ease;\n        display: flex;\n        justify-content: center;\n        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n\n        .button-content {\n          display: flex;\n          align-items: center;\n          gap: 0.75rem;\n        }\n\n        .button-text {\n          font-weight: 500;\n        }\n      }\n    }\n  }\n\n  .docviewer-wrapper .k-button-icon {\n    display: none !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
